import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';

import List from './routes/List';

const Aircrafts = ({match}) => (
	<div>
		<Switch>
			<Redirect exact from={`${match.url}/`} to={`${match.url}/list`}/>
			<Route path={`${match.url}/list`} component={ List } />
		</Switch>
	</div>
);

export default Aircrafts;


// WEBPACK FOOTER //
// ./app/used/aircrafts/index.js